import React from 'react'

//* Translations
import strings from 'translations/strings.json'

//* Styles
import styles from './Loaders.module.scss'

const Loaders = ({ children }) => {
  return (
    <div className={styles["loader-container"]}>
        <div className={styles["loader"]}>
            { children }
        </div>
    </div>
  )
}

export default Loaders

export const ToCheckoutLoader = () => {

    const LANG = document.documentElement.lang.substring(0, 2).toLowerCase()
    const STRINGS_LANG = strings.hasOwnProperty(LANG) ? strings[LANG] : strings["en"]

    return(
        <Loaders>
            <div className={styles["to-checkout-container"]}>
                <img src="https://filotrack.com/wp-content/uploads/wired-outline-478-computer-display-hover-angle.gif" alt="animated-checkout" />
                <p>{STRINGS_LANG.loader.to_checkout}</p>
            </div>
        </Loaders>
    )
}